import React, { useState } from "react";
import "./Contact.scss";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus("Sending...");

        try {
            const response = await fetch("https://techadive.com/send_mail.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams(formData),
            });

            const result = await response.text();

            if (result.trim() === "success") {
                setStatus("✅ Message sent successfully!");
                setFormData({ name: "", email: "", message: "" });
            } else {
                setStatus("❌ Failed to send message. Please try again later.");
            }
        } catch (error) {
            console.error(error);
            setStatus("❌ Something went wrong. Please try again later.");
        }

        setIsSubmitting(false);
    };

    return (
        <main className="contact-page">
            <section className="contact-page__intro">
                <h1>Let’s Build Something Great Together</h1>
                <p>
                    Whether you’re looking for a custom web app, a mobile solution, or
                    product consultation — we’re ready to help bring your ideas to life.
                </p>
            </section>

            <section className="contact-page__content">
                {/* CONTACT FORM */}
                <form className="contact-page__form" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                    <textarea
                        name="message"
                        placeholder="Your Message"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>

                    <button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? "Sending..." : "Send Message"}
                    </button>

                    {status && <p className="form-status">{status}</p>}
                </form>

                {/* MAP SECTION */}
                <div className="contact-page__map">
                    <iframe
                        title="TechADive Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1997.7345!2d36.821946!3d-1.292066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f173b0a74a4b9%3A0x48a029a55a0b8a1!2sNairobi%2C%20Kenya!5e0!3m2!1sen!2ske!4v1635727232745!5m2!1sen!2ske"                        loading="lazy"
                    ></iframe>
                </div>
            </section>
        </main>
    );
};

export default Contact;
